window["engagement-finder"] =  window['engagement-finder']  ||  {}
export default {
  name: "EngagementFinderPage",
  components: {
    ...window["engagement-finder"].default
  },
  data: () => ({
    language: "fr"
  })
};